import Icons from '../../../../assets/svgs/icons';
import React from 'react';
import swal from 'sweetalert';
import {useLocation} from 'react-router-dom';

const Footer = ({
  lock,
  current,
  canAdvance,
  canRegress,
  onAdvance,
  onSubmit,
  onSubmitSegurado,
  onRegress,
  onAddEquipament,
  isSegurado,
  success,
  goTo,
  onSubmitFotos,
  loading,
  imgLoading,
  isClicked,
  extraData,
  corPrimaria,
  isCampaign,
  cadastraCampanha,
  gerouCotacao,
  token,
}) => {
  return (
    <div className="footer" style={{pointerEvents: !lock ? 'auto' : 'none'}}>
      {isSegurado
        ? {
            0: (
              <div className="advanceDiv">
                <button
                  style={{
                    background: !!corPrimaria ? corPrimaria : '#023a86',
                  }}
                  tabIndex={-1}
                  onClick={goTo(2)}
                  disabled={!canAdvance || !extraData.segurado.segurado_bicicletas.find(({fotos_enviadas}) => fotos_enviadas)}
                  className={`advanceBtn ${!canAdvance && 'cantAdvance'}`}>
                  Avançar <Icons name="chevron_right" size="13px" className="ml-2" color="#fff" />
                </button>
              </div>
            ),
            1: (
              <div className="advanceDiv">
                <button
                  style={{
                    background: !!corPrimaria ? corPrimaria : '#023a86',
                  }}
                  tabIndex={-1}
                  onClick={onSubmitFotos}
                  disabled={!canAdvance || imgLoading}
                  className={`advanceBtn ${!canAdvance && 'cantAdvance'}`}>
                  {!imgLoading ? (
                    <>
                      Enviar fotos <Icons name="chevron_right" size="13px" className="ml-2" color="#fff" />
                    </>
                  ) : (
                    <>
                      <Icons name="spinner" size="20px" className="mr-2" color="#FFF" />
                    </>
                  )}
                </button>
              </div>
            ),
            2: (
              <div className="advanceDiv">
                <button
                  style={{
                    background: !!corPrimaria ? corPrimaria : '#023a86',
                  }}
                  tabIndex={-1}
                  onClick={onSubmitSegurado}
                  className={`advanceBtn ${!canAdvance && 'cantAdvance'}`}>
                  Contratar <Icons name="chevron_right" size="13px" className="ml-2" color="#fff" />
                </button>
              </div>
            ),
            3: (
              <div className="advanceDiv">
                <button
                  style={{
                    background: !!corPrimaria ? corPrimaria : '#023a86',
                  }}
                  tabIndex={-1}
                  type="button"
                  className={`advanceBtn finalLvl`}>
                  Obrigado!
                </button>
              </div>
            ),
          }[current]
        : {
            0: <div />,
            2: (
              <div style={{display: 'flex', flex: 1}}>
                <div className="regressDiv">
                  {(!success || gerouCotacao) && (
                    <button tabIndex={-1} onClick={onRegress} disabled={!canRegress} className="backBtn">
                      <Icons name="chevron_left" size="13px" className="mr-2" color="#fff" /> Voltar
                    </button>
                  )}
                </div>

                <div className="advanceDiv">
                  <button
                    style={{
                      background: !!corPrimaria ? corPrimaria : '#023a86',
                    }}
                    tabIndex={-1}
                    onClick={async () => {
                      if (!gerouCotacao) {
                        const resp = await swal({
                          text: 'Ao clicar em avançar você deverá inserir os dados cadastrais do segurado para formatação da proposta e disponibilização do link de vistoria. Para envio do link para vistoria clique em avançar. Para salvar a cotação clique em voltar e em seguida em gerar pdf da cotação.',
                          icon: 'warning',
                          buttons: ['Voltar', 'Avançar'],
                        });
                        if (resp) {
                          goTo(6)();
                          if (isCampaign) {
                            function gtag_report_conversion(url) {
                              var callback = function () {
                                if (typeof url != 'undefined') {
                                  window.location = url;
                                }
                              };
                              window.gtag('event', 'conversion', {
                                send_to: 'AW-10999123839/bgKKCJrwteUDEP-e5fwo',
                                event_callback: callback,
                              });
                              return false;
                            }
                            gtag_report_conversion();
                          }
                        }
                      } else {
                        goTo(6)();
                        if (isCampaign) {
                          function gtag_report_conversion(url) {
                            var callback = function () {
                              if (typeof url != 'undefined') {
                                window.location = url;
                              }
                            };
                            window.gtag('event', 'conversion', {
                              send_to: 'AW-10999123839/bgKKCJrwteUDEP-e5fwo',
                              event_callback: callback,
                            });
                            return false;
                          }
                          gtag_report_conversion();
                        }
                      }
                    }}
                    disabled={!canAdvance}
                    className={`advanceBtn ${!canAdvance && 'cantAdvance'}`}>
                    Avançar <Icons name="chevron_right" size="13px" className="ml-2" color="#fff" />
                  </button>
                </div>
              </div>
            ),
            5: (
              <div style={{display: 'flex', flex: 1}}>
                <div className="regressDiv">
                  {!success && (
                    <button tabIndex={-1} onClick={onRegress} disabled={!canRegress} className="backBtn">
                      <Icons name="chevron_left" size="13px" className="mr-2" color="#fff" /> Voltar
                    </button>
                  )}
                </div>
                {/* <div style={{display: 'flex', flex: 1}}>
                  <div className="advanceDiv">
                    <button
                      style={{
                        background: !!corPrimaria ? corPrimaria : '#023a86',
                      }}
                      tabIndex={-1}
                      onClick={() => {
                        onAdvance();
                        onAddEquipament(6);
                        if (isCampaign) {
                          function gtag_report_conversion(url) {
                            var callback = function () {
                              if (typeof url != 'undefined') {
                                window.location = url;
                              }
                            };
                            window.gtag('event', 'conversion', {
                              send_to: 'AW-10999123839/bgKKCJrwteUDEP-e5fwo',
                              event_callback: callback,
                            });
                            return false;
                          }
                          gtag_report_conversion();
                        }
                      }}
                      disabled={!canAdvance}
                      className={`advanceBtn ${!canAdvance && 'cantAdvance'}`}>
                      Avançar <Icons name="chevron_right" size="13px" className="ml-2" color="#fff" />
                    </button>
                  </div>
 */}
                <div className="advanceDiv">
                  <button
                    style={{
                      background: !!corPrimaria ? corPrimaria : '#023a86',
                    }}
                    tabIndex={-1}
                    onClick={() => {
                      onAdvance();
                      onAddEquipament(2);
                      if (isCampaign) {
                        function gtag_report_conversion(url) {
                          var callback = function () {
                            if (typeof url != 'undefined') {
                              window.location = url;
                            }
                          };
                          window.gtag('event', 'conversion', {
                            send_to: 'AW-10999123839/bgKKCJrwteUDEP-e5fwo',
                            event_callback: callback,
                          });
                          return false;
                        }
                        gtag_report_conversion();
                      }
                    }}
                    disabled={!canAdvance}
                    className={`advanceBtn ${!canAdvance && 'cantAdvance'}`}>
                    Avançar <Icons name="chevron_right" size="13px" className="ml-2" color="#fff" />
                  </button>
                </div>
              </div>
            ),
            6: (
              <div style={{display: 'flex', flex: 1}}>
                <div className="regressDiv">
                  {!success && (
                    <button tabIndex={-1} onClick={goTo(2)} disabled={!canRegress} className="backBtn">
                      <Icons name="chevron_left" size="13px" className="mr-2" color="#fff" /> Voltar
                    </button>
                  )}
                </div>

                <div className="advanceDiv">
                  <button
                    style={{
                      background: !!corPrimaria ? corPrimaria : '#023a86',
                    }}
                    tabIndex={-1}
                    onClick={onAdvance}
                    disabled={!canAdvance}
                    className={`advanceBtn ${!canAdvance && 'cantAdvance'}`}>
                    Avançar <Icons name="chevron_right" size="13px" className="ml-2" color="#fff" />
                  </button>
                </div>
              </div>
            ),
            7: (
              <div style={{display: 'flex', flex: 1}}>
                <div className="regressDiv">
                  {!success && !isClicked && (
                    <button tabIndex={-1} onClick={onRegress} disabled={!canRegress} className="backBtn">
                      <Icons name="chevron_left" size="13px" className="mr-2" color="#fff" /> Voltar
                    </button>
                  )}
                  {/*  {success && (
                    <button
                      tabIndex={-1}
                      onClick={() => window.open(window.location.origin + '/corretor')}
                      disabled={!canRegress}
                      className="backBtn">
                      <Icons name="chevron_left" size="13px" className="mr-2" color="#fff" /> Realizar nova cotação
                    </button>
                  )} */}
                </div>

                <div className="advanceDiv">
                  <button
                    style={{
                      background: !!corPrimaria ? corPrimaria : '#023a86',
                    }}
                    key="button"
                    tabIndex={-1}
                    onClick={() => onSubmit({tipo: 'pdf'})}
                    disabled={!canAdvance || loading}
                    className="advanceBtn">
                    {!loading &&
                      (!success ? (
                        <>
                          <Icons key="icone" name="save" size="13px" className="mr-2" color="#fff" />
                          <span key="downloadBtn">Gerar proposta</span>
                        </>
                      ) : (
                        <>
                          <Icons key="icone" name="download" size="13px" className="mr-2" color="#fff" />
                          <span key="downloadBtn">Fazer download do pdf</span>
                        </>
                      ))}

                    {loading && (
                      <>
                        <Icons name="spinner" size="20px" className="mr-2" color="#FFF" />
                        <span key="downloadBtn">Gerando PDF, aguarde ...</span>
                      </>
                    )}
                  </button>
                </div>
              </div>
            ),
            4: (
              <div style={{display: 'flex', flex: 1}}>
                <div className="regressDiv">
                  {!success && !isClicked && (
                    <button tabIndex={-1} onClick={onRegress} disabled={!canRegress || success} className="backBtn">
                      <Icons name="chevron_left" size="13px" className="mr-2" color="#fff" /> Voltar
                    </button>
                  )}
                </div>

                <div className="advanceDiv">
                  <button
                    style={{
                      background: !!corPrimaria ? corPrimaria : '#023a86',
                    }}
                    tabIndex={-1}
                    onClick={onAdvance}
                    disabled={!canAdvance}
                    className={`advanceBtn ${!canAdvance && 'cantAdvance'}`}>
                    Avançar <Icons name="chevron_right" size="13px" className="ml-2" color="#fff" />
                  </button>
                </div>
              </div>
            ),
          }[current] ?? (
            <div style={{display: 'flex', flex: 1}}>
              <div className="regressDiv">
                {!success && !isClicked && (
                  <button tabIndex={-1} onClick={onRegress} disabled={!canRegress || success} className="backBtn">
                    <Icons name="chevron_left" size="13px" className="mr-2" color="#fff" /> Voltar
                  </button>
                )}
              </div>

              <div className="advanceDiv">
                <button
                  style={{
                    background: !!corPrimaria ? corPrimaria : '#023a86',
                  }}
                  tabIndex={-1}
                  onClick={() => {
                    onAdvance();
                    if (isCampaign && !cadastraCampanha()) {
                      function gtag_report_conversion(url) {
                        var callback = function () {
                          if (typeof url != 'undefined') {
                            window.location = url;
                          }
                        };
                        window.gtag('event', 'conversion', {
                          send_to: 'AW-10999123839/_vcVCIXwteUDEP-e5fwo',
                          event_callback: callback,
                        });
                        return false;
                      }
                      gtag_report_conversion();
                      cadastraCampanha();
                    }
                  }}
                  disabled={!canAdvance}
                  className={`advanceBtn ${!canAdvance && 'cantAdvance'}`}>
                  Avançar <Icons name="chevron_right" size="13px" className="ml-2" color="#fff" />
                </button>
              </div>
            </div>
          )}
    </div>
  );
};

export default Footer;
